export function useRemoveSafeStorage(key: string) {
  if (process.client) {
    const cookieRef = useCookie<string | null>(key, {
      sameSite: 'lax',
      secure: true,
      path: '/',
    })

    localStorage.removeItem(key)
    cookieRef.value = null

    if (key === 'access_token') {
      useRemoveSafeStorage('auth_restaurant_slug')
    }
  }
}